// extracted by mini-css-extract-plugin
module.exports = {"errorMessage":"ErrorMessage_errorMessage__V5kYF"};